export default async function decorate(block) {
  const content = block.querySelector(':scope > div > div');
  if (content) {
    block.replaceChildren(...content.childNodes);
  }
}
